import React from "react";
import { Link } from "react-router-dom";
import { History, ArrowUpRight } from "lucide-react";
import { CHART_YEARS } from "../mock";

const SECTIONS = [
  { key: "madhur", label: "Madhur Chart History", path: "/madhur-chart" },
  { key: "starline", label: "Starline Chart History", path: "/starline-chart" },
];

export default function ChartArchive() {
  return (
    <section className="py-16 bg-gradient-to-b from-transparent to-amber-950/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-amber-300 mb-2">
          <History className="w-5 h-5" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em]">Archive</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-100">Chart History Archive</h2>
        <p className="mt-2 text-slate-400 max-w-2xl">
          Year-wise complete record dekhne ke liye niche diye gaye sections explore karein.
        </p>

        <div className="mt-8 grid md:grid-cols-2 gap-5">
          {SECTIONS.map((s) => (
            <div key={s.key} className="rounded-2xl border border-white/5 bg-[#11172a] p-6 hover:border-amber-400/30 transition-colors">
              <div className="flex items-start justify-between">
                <h3 className="text-lg font-semibold text-slate-100">{s.label}</h3>
                <Link
                  to={s.path}
                  className="text-amber-300 hover:text-amber-200 inline-flex items-center gap-1 text-sm"
                >
                  Open <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {CHART_YEARS.map((y) => (
                  <Link
                    key={y}
                    to={`${s.path}?year=${y}`}
                    className="px-3 py-1.5 text-xs rounded-md bg-white/[0.04] border border-white/5 text-slate-300 hover:bg-amber-400/10 hover:text-amber-200 hover:border-amber-400/30 transition-colors font-mono"
                  >
                    {y}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
